import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/limited.svg';

export const IconLimited = createIconComponent(Icon);
